/**
 * Style — a <style> element whose CSS survives server rendering.
 *
 * React escapes text children, but <style> is a raw-text element: the browser
 * never decodes entities inside it. A server-rendered <style>{css}</style> therefore
 * ships literal `&gt;` and `&quot;` into the stylesheet, silently breaking every rule
 * that uses a child combinator or an attribute selector ([data-theme="dark"]) — and
 * the escaped text node also differs from the one the browser builds, so hydration
 * fails and React throws the prerendered DOM away.
 *
 * dangerouslySetInnerHTML writes the CSS verbatim, which is what a <style> element
 * needs. Safe here because every caller passes a static, developer-authored constant;
 * never pass user input through this component.
 */
export default function Style({ children }) {
  return <style dangerouslySetInnerHTML={{ __html: String(children ?? '') }} />;
}
